export const titleTranslation = {
    en: "About",
    he: "אודות",
    ar: "من أنا",
};

export const introTranslation = {
    title: {
        en: "Hii there",
        he: "ברוכים הבאים",
        ar: "أهلًا وسهلًا",
    },
    intro: {
        en: 'If you\'re looking for a developer who is passionate about programming, developing, and design, then look <span class="color-red">no</span> further!',
        he: "אם אתם מחפשים מפתח אתרים שמתפנה לתכנות, לפיתוח ולעיצוב ברגע שלכם, אז אתם במקום הנכון!",
        ar: "إذا كنت تبحث عن مطور يشعر بالشغف تجاه البرمجة والتطوير والتصميم، فلا داعي للبحث أكثر!",
    },
};

export const contentTranslation = [
    {
        en: "My name is <span class='colorful-name'>Yousef</span>, I'm a creative full-stack developer with a passion for developing web apps that not only look great, but also function seamlessly. With a strong background in both frontend and backend programming, I have a keen eye for design and a problem-solving mindset that allows me to craft innovative solutions for complex challenges.",
        he: "אני <span class='colorful-name'>יוסף</span>, מפתח יצירתי עם תשוקה לפיתוח אתרים שלא רק נראים נהדר, אלא גם מתפקדים בצורה חלקה. עם רקע חזק בפיתוח צד לקוח וצד שרת, יש לי עין חדה לעיצוב ומחשבה של פתרון בעיות המאפשרת לי ליצור פתרונות חדשניים לאתגרים מורכבים.",
        ar: "أدعى <span class='colorful-name'>يوسف</span>، أنا مطور إبداعي بامتياز ومتخصص في تطوير تطبيقات الويب التي لا تبدو رائعة فحسب، بل تعمل بسلاسة أيضًا. بفضل خبرتي الواسعة في برمجة الواجهة الأمامية والخلفية، لدي عين حادة للتصميم وعقلية حل المشكلات التي تتيح لي صياغة حلول مبتكرة للتحديات المعقدة.",
    },
    {
        en: "As a developer, I am always seeking to push the boundaries of what is possible and bring new ideas to life through my work. Whether I am developing a custom web app from scratch or refining an existing project, I am always looking for ways to make the end results better and more user-friendly.",
        he: "כמפתח, אני תמיד מחפש לדחוף את הגבולות של מה שאפשר ולהביא רעיונות חדשים לחיים באמצעות העבודה שלי. בין אם אני מפתח אתר מותאם אישית מאפס או משכלל פרויקט קיים, אני תמיד מחפש דרכים להפוך את התוצאות הסופיות לטובות יותר וידידותיות יותר למשתמש.",
        ar: "كمطور، أسعى دائمًا لدفع حدود ما هو ممكن وإحياء أفكار جديدة من خلال عملي. سواء كنت أطور تطبيق ويب مخصص من البداية أو أقوم بتحسين مشروع موجود، فأنا أبحث دائمًا عن طرق لجعل النتائج النهائية أفضل وأكثر سهولة في الاستخدام.",
    },
    {
        en: "I am confident that I have the skills and expertise to help you bring your web app or website to life. Thank you for visiting my portfolio website, and I look forward to working with you!",
        he: "אני בטוח שיש לי את הכישורים והמומחיות לעזור לך להחיות את האתר שלך. תודה שביקרת באתר שלי, ואני מצפה לעבוד איתך!",
        ar: "أنا واثق من أن لدي المهارات والخبرات اللازمة لمساعدتك في جلب تطبيقك الويب أو موقعك إلى الحياة. شكرًا لزيارة موقعي الإلكتروني الخاص بالأعمال الإبداعية، وأتطلع إلى العمل معك!",
    },
];
